import React, { useCallback } from 'react'
import { Grid } from 'semantic-ui-react'
import DropDown from '@commonComponents/formComponents/CustomDropDown'
import InputField from '@commonComponents/formComponents/CustomInputField'

export const MerchForm1 = React.memo(
  ({
    dataSource: {
      id: merchandiseId,
      invoiceId,
      commercialDescription,
      sku,
    },
    packageDataSource,
    packages,
    onSelect,
    onBlur,
    onChange,
    packageTypeList,
    isDMS,
    isImportShipment,
    validateLineItem,
    isMerchandiseDisabled
  }) => {

    const {
      type,
      quantity,
      shippingMarks
    } = packageDataSource?.slice(-1)[0] || {}

    const onChangeHandler = useCallback(
      ({target: {value, name}}) => onChange(value, name ),
      [merchandiseId, onChange]
    )
    const onDropDownChange = useCallback(
      (e, {value, name}) => onSelect(value, name),
      [merchandiseId, onSelect]
    )
    const onBlurHandler = useCallback(
      ({target: {value, name}}) =>{
        if(validateLineItem) validateLineItem(name, value)
        onBlur(value, name)
      },
      [merchandiseId, onBlur]
    )
    return (
      <>
        <Grid.Column width='6'>
          <InputField
            id={`commercialDescription-${invoiceId}-${merchandiseId}`}
            type='text'
            label="DESCRIPTION_OF_GOODS"
            boxNumber='6/8'
            value={commercialDescription}
            name='commercialDescription'
            onChange={onChangeHandler} 
            onBlur={onBlurHandler}
            isDisabled={isMerchandiseDisabled}
          />
        </Grid.Column>
        <Grid.Column>
          <InputField
            id={`sku-${invoiceId}-${merchandiseId}`}
            type='text'
            label={(isDMS && isImportShipment?'PART_NUMBER':'SKU')}
            value={sku}
            name='sku'
            onChange={onChangeHandler} 
            onBlur={onBlurHandler}
            isDisabled={isMerchandiseDisabled}
          />
        </Grid.Column>
        <Grid.Column style={{display:'flex'}}>
          <DropDown
            id={`packagesList.toBeHighlight-${invoiceId}-${merchandiseId}`}
            // id={`pkgType-${invoiceId}-${merchandiseId}`}
            label="PKG_TYPE"
            className='field-bg dropdown100'
            fieldClassName='wp-85'
            boxNumber='6/9'
            labelClass='text-none'
            isLabel={true}
            data={packageTypeList}
            clearable
            value={type || ''}
            text={type}
            name='type'
            isDisabled={true}
            onChange={onDropDownChange}
          />
          {packages && packages(packageDataSource)}
        </Grid.Column>
        <Grid.Column>
          <InputField
            id={`quantity-${invoiceId}-${merchandiseId}`}
            type='text'
            label="PKG_QTY"
            boxNumber='6/10'
            value={quantity || ''}
            name='quantity'
            onChange={onChangeHandler} 
            onBlur={onBlurHandler}
            isDisabled={true}
          />
        </Grid.Column>
        <Grid.Column width='2'>
          <InputField
            id={`shippingMarks-${invoiceId}-${merchandiseId}`}
            type='text'
            label="SHIPPING_MARKS"
            boxNumber='6/11'
            value={shippingMarks || ''}
            name='shippingMarks'
            onChange={onChangeHandler} 
            onBlur={onBlurHandler}
            isDisabled={true}
          />
        </Grid.Column>
      </>
    )
  }
)
